import type { FilterableMenuItem } from 'owa-filterable-menu';
import type { AssetDescriptor } from 'owa-timestream-asset-sdk-types';
import {
    CreateAssetMenuItemsConfig,
    lazyGetCreateAssetMenuItems,
} from 'owa-calendar-board-commanding';

export function getCreateAssetMenuItem(
    assets: AssetDescriptor[],
    config: CreateAssetMenuItemsConfig
): FilterableMenuItem {
    const getCreateAssetMenuItem = lazyGetCreateAssetMenuItems.tryImportForRender();

    return getCreateAssetMenuItem ? getCreateAssetMenuItem(assets, config) : null;
}
